/**
 * Train 8 (Sean 2026-09-23): the nav header "Skills & Logic" reads **Agents**, rows Skills / Logic (Method for a
 * partner seat) / Definitions / Jobs. The collapsed rail carries one icon for the group, active on any of its rows'
 * routes. `/threads*` is the pre-rename alias of `/agent-jobs` (router.tsx keeps the redirect).
 */
export function isAgentsGroupPath(pathname: string): boolean {
  return /^\/(?:firm\/(?:skills|logic|definitions)|agent-jobs|threads)(?:\/|$)/.test(pathname)
}
